<template>
  <v-footer
    color="#1D2939"
    style="margin-top: auto"
    class="white--text text-caption"
  >
    <v-row no-gutters justify="center" align="center" class="py-2">
      <v-col cols="12" class="d-flex justify-center align-center flex-wrap">
        <v-img
          src="@/assets/logofs_icon.svg"
          max-width="65"
          class="mr-2"
          contain
        ></v-img>
        <span
          class="white--text"
          style="margin-bottom: 2px"
        >
          Copyright © 2026 Forward System Limited. All rights reserved.
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style>
.inline-container {
  text-align: center;
}

.inline-item {
  display: inline-block;
  vertical-align: middle;
}

.inline-container span {
  font-size: small;
  margin-bottom: 5px;
  color: white;
}
</style>
